import styled, { css } from 'styled-components';

import { IconSize } from './icon.types';

export const IconWrapper = styled.i<{
  $color: string;
  $reverse?: boolean;
  $size?: IconSize;
}>(({ $color, $reverse, $size }) => {
  let px;
  switch ($size) {
    case IconSize.XL:
      px = '32px';
      break;
    case IconSize.L:
      px = '24px';
      break;
    case IconSize.M:
      px = '20px';
      break;
    case IconSize.S:
      px = '16px';
      break;
    case IconSize.XS:
      px = '12px';
      break;
    default:
      px = 'auto';
      break;
  }
  return css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${px};
    height: ${px};
    > svg {
      fill: ${$color};
      ${$reverse ? 'transform: rotate(180deg);' : ''};
      > path {
        fill-rule: evenodd;
        clip-rule: evenodd;
      }
    }
  `;
});
